import _ from 'lodash';
import {
    FETCH_RAINPRO_SELLER_ORDERS,
    CLEAN_RAINPRO_SELLER_ORDERS,
    SYNC_RAINPRO_SELLER_ORDER,
    EDIT_RAINPRO_SELLER_ORDER,
    CHANGE_RAINPRO_SELLER_ORDER_STATE,
    PICKUP_RAINPRO_SELLER_ORDER,
    READY_RAINPRO_SELLER_ORDER,
} from './types';
import { request, __ } from '../functions';

export const fetchRainproSellerOrders = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
        callback: null,
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    let uri = '/rainpro/sellerOrders';

    return dispatch => request(uri, params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        if (options.callback !== null) {
            // Zavolame callback
            options.callback();
        }

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_RAINPRO_SELLER_ORDERS, payload: data });
    });
};

export const cleanRainproSellerOrders = () => ({ type: CLEAN_RAINPRO_SELLER_ORDERS });

export const syncRainproSellerOrder = (screen, id) => {
    return dispatch => request(`/rainpro/syncSellerOrder/${id}`).then(response => {
        const { status, data } = response.data;

        if (status === 'error') {
            // Objednavku sa nepodarilo synchronizovat
            screen.showSnackbar('error', __('Objednávku sa nepodarilo synchronizovať'));
            return;
        }

        screen.showSnackbar('success', __('Objednávka bola zosynchronizovaná s eshopom'));

        dispatch({ type: SYNC_RAINPRO_SELLER_ORDER, payload: data });
    });
};

export const changeRainproSellerOrderState = (screen, id, stateId) => {
    return dispatch => request(`/rainpro/changeSellerOrderState/${id}/${stateId}`).then(response => {
        const { status, data } = response.data;

        if (status === 'error') {
            // Stav sa nepodarilo zmenit
            screen.showSnackbar('error', __('Stav objednávky sa nepodarilo zmeniť'));
            return;
        }

        screen.showSnackbar('success', __('Stav objednávky bol zmenený'));

        dispatch({ type: CHANGE_RAINPRO_SELLER_ORDER_STATE, payload: data });
    });
};

export const pickupRainproSellerOrder = (screen, id, password) => {
    return dispatch => request(`/rainpro/pickupSellerOrder/${id}/${password}`).then(response => {
        const { status, data } = response.data;

        if (status === 'error') {
            // Objednavku sa nepodarilo synchronizovat
            screen.showSnackbar('error', __('Heslo k objednávke nie je správne'));
            return;
        }

        screen.showSnackbar('success', __('Objednávka bola vyzdvihnutá'));

        dispatch({ type: PICKUP_RAINPRO_SELLER_ORDER, payload: { id, data } });
    });
};

export const readyRainproSellerOrder = (screen, id) => {
    return dispatch => request(`/rainpro/readySellerOrder/${id}`).then(response => {
        const { status, data } = response.data;

        if (status === 'error') {
            // Objednavku sa nepodarilo synchronizovat
            screen.showSnackbar('error', __('Objednávku sa nepodarilo označiť ako pripravenú na vyzdvihnutie'));
            return;
        }

        screen.showSnackbar('success', __('Objednávka bola označená ako pripravená na vyzdvihnutie'));

        dispatch({ type: READY_RAINPRO_SELLER_ORDER, payload: { id, data } });
    });
};

export const changeRainproSellerOrderData = (id, data) => ({ type: EDIT_RAINPRO_SELLER_ORDER, payload: { id, data } });
